/**
 * V36.85 — Helper de navigation role-aware.
 *
 * Centralise la résolution du tableau de bord à utiliser après une action
 * "Retour", "Accueil", "Tableau de bord" ou "Quitter" depuis un workflow
 * partagé (souscription annuelle, SEPA, calculateur, etc.).
 *
 * Avant V36.85, plusieurs composants hardcodaient `/cooper/dashboard`
 * — ce qui faisait sortir un super_admin connecté de son espace
 * d'administration (cf. bug remonté par l'utilisateur le 05/06/2026).
 *
 * Usage :
 *   import { getDashboardRouteForRole } from '../utils/roleNavigation';
 *   const route = getDashboardRouteForRole(user?.role);
 *   navigate(route);
 */

const DASHBOARD_BY_ROLE = {
  super_admin: '/admin/super-dashboard',
  admin: '/admin/dashboard',
  cooper: '/cooper/dashboard',
  member: '/member/dashboard',
  expert: '/expert/dashboard',
};

export function getDashboardRouteForRole(role) {
  const normalized = (role || '').toString().toLowerCase();
  return DASHBOARD_BY_ROLE[normalized] || '/';
}

export default getDashboardRouteForRole;
